import React from 'react';
export const Newsletter = () => {
  return <section className="py-16 md:py-24 bg-scarlet text-white" data-id="element-115">
      <div className="container mx-auto px-4" data-id="element-116">
        <div className="max-w-2xl mx-auto text-center" data-id="element-117">
          <h2 className="font-heading text-3xl md:text-4xl mb-4 uppercase tracking-wide" data-id="element-118">
            Get First Access to New Drops
          </h2>
          <p className="text-white/90 mb-8 text-lg" data-id="element-119">
            Join our newsletter for exclusive alerts on rare cards, new
            signings, and special promotions.
          </p>
          <form className="flex flex-col sm:flex-row gap-3 w-full max-w-md mx-auto" onSubmit={e => e.preventDefault()} data-id="element-120">
            <input type="email" placeholder="Enter your email address" className="flex-grow px-4 py-3 rounded-lg text-ink min-h-[44px] focus:outline-none focus:ring-2 focus:ring-ink" required data-id="element-121" />
            <button type="submit" className="bg-ink text-white font-bold uppercase tracking-wider px-6 py-3 rounded-lg hover:bg-ink/90 transition-colors min-h-[44px] flex items-center justify-center whitespace-nowrap" data-id="element-122">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>;
};